import React from 'react';
import Icon from '../../../components/AppIcon';

const SolarEnergySection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-background to-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center mb-4 px-4 py-2 rounded-full bg-primary/10 text-primary border border-primary/20">
            <Icon name="Sparkles" size={20} className="mr-2" />
            <span className="text-sm font-medium">Infraestrutura Sustentável</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
            Eficiência e Operação Inteligente
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Estrutura preparada para distribuir energia e recursos para todo o prédio,
            com foco em eficiência, estabilidade e operação contínua.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          <div className="bg-card rounded-2xl p-8 border border-border shadow-warm">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                <Icon name="Zap" size={24} className="text-primary" />
              </div>
              <div>
                <h3 className="text-xl font-heading font-semibold text-foreground mb-3">
                  Distribuição para Todo o Prédio
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  A infraestrutura foi planejada para atender todas as áreas do empreendimento,
                  garantindo suporte às operações comerciais e aos serviços.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-card rounded-2xl p-8 border border-border shadow-warm">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                <Icon name="Droplets" size={24} className="text-primary" />
              </div>
              <div>
                <h3 className="text-xl font-heading font-semibold text-foreground mb-3">
                  Tratamento de Esgoto Próprio
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  Estação de tratamento dedicada ao empreendimento, aumentando a autonomia
                  operacional e a eficiência do funcionamento diário.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolarEnergySection;
